import { AnalyticsProjection } from '@sprinklr/stories/analytics/AnalyticsRequest';
import Metric from '@sprinklr/stories/analytics/Metric';

export function getIsDuration(projection: AnalyticsProjection & Partial<Metric>): boolean {
    const { type, details } = projection || {};
    const { dataType } = details || {};

    switch (type) {
        case 'TIME_INTERVAL':
        case 'TIME_DIFFERENCE':
            return true;
    }
    switch (dataType) {
        case 'TIME_DIFFERENCE':
        case 'DATE_HISTOGRAM':
        case 'DATETIME':
            return true;
    }
    return false;
}
